<template>
  <!-- Zoom is driven by the parent (Files.vue) so there is a single control set;
       `renderWidth` overrides the standalone default when supplied. -->
  <div class="container" :style="{ minWidth: `${renderWidth || widthPdf}px` }">
    <v-progress-linear class="mt-1" indeterminate color="primary" v-if="loading"></v-progress-linear>
    <pdf
      v-for="i in numPages"
      :key="i"
      :src="src"
      :page="i"
      style="display: inline-block;width:100%; height:auto;margin:2px 0;"
      @loaded="loading = false"
    ></pdf>
    <!-- Only shown when the parent isn't supplying zoom, so screens that embed this
         directly keep their controls without duplicating Files.vue's set. -->
    <div class="pdf__zoom-box" v-if="!renderWidth">
      <button @click="pluspdfwidth(widthPdf)">+</button>
      <button @click="minspdfwidth(widthPdf)">-</button>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  props: {
    fileUrl: {},
    // px width to render pages at; falls back to `widthPdf` when not provided
    renderWidth: { type: Number, default: 0 }
  },
  components: {
    pdf: pdf
  },
  data () {
    return {
      numPages: 0,
      loading: false,
      src: undefined,
      widthPdf: 700
    }
  },
  mounted () {
    this.loading = true
    this.src = pdf.createLoadingTask(this.fileUrl)
    this.src.promise.then(pdfDoc => {
      this.numPages = pdfDoc.numPages
    }).catch(err => {
      if (err && err.name !== 'RenderingCancelledException') {
        console.error('PDF load error:', err)
        // let the host screen react (Files.vue shows its "file not found" snackbar)
        this.$emit('error', err)
      }
      this.loading = false
    })
  },
  beforeDestroy () {
    if (this.src && typeof this.src.destroy === 'function') {
      this.src.destroy()
    }
    this.src = null
  },
  methods: {
    pluspdfwidth (item) {
      if (item < 2500) {
        this.widthPdf += 100
      }
    },
    minspdfwidth (item) {
      if (item > 500) {
        this.widthPdf -= 100
      }
    }
  }
}
</script>

<style>
span.annotationLayer {
  border: 1px solid rgba(0, 0, 0, 0.5) !important;
}
/* Deliberately not named .button__box: this stylesheet is global, and the old shared
   name leaked these rules into Files.vue's control stack. */
.pdf__zoom-box{
  position: fixed;
  bottom: 60px;
  right: 10px;
  background-color: #424242;
  z-index: 9999;
  display: none;
  flex-direction: column;
  border-radius: 0 !important;
}
@media only screen and (max-width: 1299px){
  .pdf__zoom-box{
    display: flex;
  }
}
.pdf__zoom-box button{
  padding: 14px 15px;
  color: #fff;
  font-size: 24px;
  line-height: 1;
}
.pdf__zoom-box button:hover{
  background-color: #707070;
}
</style>
